import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }

import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";

import { shareholderStore } from "@/stores/shareholder";
import ShareholderDividendsTable from "@/components/organisms/ShareholderDividendsTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyDividendsView',
  setup(__props) {


const shareholderStr = shareholderStore();
const router = useRouter();

const shareholderId = computed(() =>
  Number(router.currentRoute.value.params.id)
);

onMounted(() => {
  shareholderStr.query(shareholderId.value);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ShareholderDividendsTable)
  ]))
}
}

})